export default "__VITE_ASSET__A_4bb33J__"